import React from 'react'
import InlineSVG from "react-inlinesvg";
import addSuccessIcon from "../../../../icon/add-success.svg";
import addIcon from "../../../../icon/stock-add.svg";
import styles from "./FJAddButton.module.less";
import FJIconButton from "../../../../common/component/button-icon/FJIconButton";
import classNames from 'classnames'

function FJAddButton(props) {
	const {selected, onClick, className} = props;
	const _className = classNames(selected ? styles.add_success_btn : styles.add_btn, className);
	return (
		<div className={styles.box}>
			<FJIconButton icon={<InlineSVG src={selected ? addSuccessIcon : addIcon}/>}
			              className={_className}
			              onClick={onClick}
			/>
		</div>
	);
}

export default FJAddButton;